<template>
  <div :class="$style.coachingPage">

    <app-loader :show-loader="getLoadingStatus"/>

    <h2>Buy Coaching</h2>
    <p>Need help? We provide consultation service. Please select one coaching option.</p>

    <app-data-table v-if="getFilteredProducts.length > 0"
                    :products-table="true"
                    :class="$style.productsTable"
                    table-title="List of Coaching Options"
                    :headers="coachingHeaders"
                    :items="getFilteredProducts"
    >
      <template v-slot:tableRows>
        <tr v-for="item in getFilteredProducts"
            :key="item.id"
            :class="$forms.tableDataRow">
          <td>
            {{ item.name }}
          </td>
          <td>
            ${{ item.price.toFixed(2) }}
          </td>
          <td :class="$forms.tableRowButtons">
            <app-button :class="$style.tableBtn"
                        text="Select"
                        button-style="accent"
                        @click.prevent="selectCoaching(item.id)" />
          </td>
          <td></td>
        </tr>
      </template>
    </app-data-table>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  data() {
    return {
      coachingHeaders: [
        'Product',
        'Price',
      ],
      loading: false,
    };
  },
  methods: {
    ...mapActions([
      'fetchAppProducts',
    ]),
    selectCoaching(id) {
      this.$router.push({ name: 'payment', query: { paymentType: 'coaching' }, params: { productId: id } });
    },
  },
  computed: {
    ...mapGetters([
      'getUserId',
      'getAppProducts',
    ]),
    getFilteredProducts() {
      if (this.getAppProducts.length > 0) {
        return this.getAppProducts.filter(product => product.name.includes('Coaching'));
      }
      return [];
    },
    getLoadingStatus() {
      return this.loading;
    },
  },
  created() {
    this.loading = true;
    this.fetchAppProducts(this.getUserId)
      .then(() => {
        this.loading = false;
      })
      .catch(() => {
        this.loading = false;
      });
  },
};
</script>

<style src="@/styles/forms.scss" lang="scss" module="$forms"></style>
<style lang="scss" module>
@import "@/styles/variables.scss";

.coachingPage {
  width: 100%;
  min-height: 100%;
  padding: 70px 60px;
}

.productsTable {
  th:nth-child(2),
  td:nth-child(2){
    text-align: right;
    padding-right: 150px !important;
  }
}

.tableBtn {
  padding: 6px 26px;
  font-size: 1.4rem;
  line-height: 1.6rem;
}
</style>
